import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import CloseModal from "../../../components/icons/CloseModal";

const MetadataModal = ({ showMetadataDetailsModal, setShowMetadataDetailsModal }) => {
  const [metadata, setMetadata] = useState({});

  const closeModal = () => {
    setMetadata({});
    setShowMetadataDetailsModal(null);
  };

  useEffect(() => {
    if (showMetadataDetailsModal?.video) {
      setMetadata(showMetadataDetailsModal?.video);
    }
  }, [showMetadataDetailsModal]);

  return (
    <>
      <Modal
        isOpen={showMetadataDetailsModal}
        onRequestClose={closeModal}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        contentLabel="Show Clip Metadata Details"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Clip Metadata Details</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <div className="verifyContentContainer">
            {metadata?.bitrate && (
              <div className="verifyContent">
                <div className="verifyContentTitle">Bitrate</div>
                <div>{metadata.bitrate?.toFixed(2)} MBPS</div>
              </div>
            )}
            {metadata?.fps && (
              <div className="verifyContent">
                <div className="verifyContentTitle">FPS</div>
                <div>{metadata.fps} FPS</div>
              </div>
            )}
            {metadata?.width && (
              <div className="verifyContent">
                <div className="verifyContentTitle">Width</div>
                <div>{metadata.width} px</div>
              </div>
            )}
            {metadata?.height && (
              <div className="verifyContent">
                <div className="verifyContentTitle">Height</div>
                <div>{metadata.height} px</div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MetadataModal;
